<div class="container mx-auto" id="acp-launchpad-overview-component">

  @if (!isUnauthorized()) {
    <!-- launchpad Overview Component -->
    <div class="mt-8">
      <!-- Title Section -->
      <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">
        {{ "launchpad.title" | translate }}
      </h1>
      <div class="mt-2 text-base text-gray-600 dark:text-gray-400">
        {{ "launchpad.description" | translate }}
      </div>
    </div>
    <!-- 🌀 Loading state -->
    @if (!isLaunchpadAppsLoading()) {
      @if (launchpadApps() && launchpadApps().length > 0) {
        <div class="mt-8">
          <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 items-stretch">
            @for (app of launchpadApps(); track app) {
              <ng-container *ngTemplateOutlet="launchpadAppCard; context: { $implicit: app, isRequiredAccess:false }"></ng-container>
            }
          </div>
        </div>
      }
    } @else {
      <div class="mt-8">
        <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 items-stretch">
          @for (_ of [].constructor(10); track _) {
            <div
              class="col-span-1 bg-white dark:bg-[var(--p-content-background)] border border-gray-300 rounded-lg p-4 flex flex-col justify-between">
              <!-- Image skeleton -->
              <p-skeleton height="8rem" class="mb-4"></p-skeleton>
              <!-- Title + icon skeleton -->
              <div class="flex justify-between items-center mb-2">
                <p-skeleton width="70%" height="1.25rem"></p-skeleton>
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
              </div>
              <!-- Short description skeleton -->
              <p-skeleton width="90%" height="0.75rem" class="mb-1"></p-skeleton>
              <p-skeleton width="60%" height="0.75rem"></p-skeleton>
              <!-- Link skeleton -->
              <div class="mt-4 text-right">
                <p-skeleton width="40%" height="1rem"></p-skeleton>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!isRequiredAccessAppsLoading()) {
      @if (requiredAccessApps() && requiredAccessApps().length > 0) {
        <div class="mt-8">
          <h1 class="font-['Apex_Rounded_Medium'] lg:text-2xl text-lg">
            {{ "launchpad.requiredAccessTitle" | translate }}
          </h1>
          <div class="mt-2 text-base text-gray-600 dark:text-gray-400 mb-8">
            {{ "launchpad.requiredAccessMessage" | translate }}
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 items-stretch">
            @for (app of requiredAccessApps(); track app) {
              <ng-container *ngTemplateOutlet="launchpadAppCard; context: { $implicit: app, isRequiredAccess: true }"></ng-container>
            }
          </div>
        </div>
      }
    } @else {
      <div class="mt-8">
        <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 items-stretch">
          @for (_ of [].constructor(10); track _) {
            <div
              class="col-span-1 bg-white dark:bg-[var(--p-content-background)] border border-gray-300 rounded-lg p-4 flex flex-col justify-between">
              <!-- Image skeleton -->
              <p-skeleton height="8rem" class="mb-4"></p-skeleton>
              <!-- Title + icon skeleton -->
              <div class="flex justify-between items-center mb-2">
                <p-skeleton width="70%" height="1.25rem"></p-skeleton>
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
              </div>
              <!-- Short description skeleton -->
              <p-skeleton width="90%" height="0.75rem" class="mb-1"></p-skeleton>
              <p-skeleton width="60%" height="0.75rem"></p-skeleton>
              <!-- Link skeleton -->
              <div class="mt-4 text-right">
                <p-skeleton width="40%" height="1rem"></p-skeleton>
              </div>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div class="container mx-auto md:text-base text-sm">
      <div class="mt-8 text-center lg:w-[75%] w-full mx-auto">
        <h1 class="font-['Apex_Rounded_Medium'] lg:text-2xl text-xl">{{ "unauthorizedToViewApps" | translate }}</h1>
      </div>
      <div class="flex">
        <img src="assets/ACP-Error-bot_warning.webp" alt="Image of a sad face" class="mx-auto w-full sm:w-1/2" />
      </div>
    </div>
  }


</div>

<!-- Card Template -->
<ng-template #launchpadAppCard let-app let-isRequiredAccess="isRequiredAccess">
  <div
    class="relative col-span-1 bg-white dark:bg-[var(--p-content-background)] border border-gray-300 rounded-lg p-4 flex flex-col justify-between hover:shadow-lg transition-shadow duration-300 overflow-hidden">

    <!-- 🔒 VPN Required Ribbon -->
    @if (app?.vpnRequired) {
      <div
        class="absolute top-0 left-0 bg-[#148bea] text-white text-xs font-semibold px-2 py-1 flex items-center gap-1 rounded-br-lg shadow-md">
        <img src="assets/vpn-icn.png" alt="" class="xl:w-6 w-4">
        <span>{{'launchpad.vpnRequired' | translate}}</span>
      </div>
    }

    <!-- ❤️ Favourite -->
    @if (!isRequiredAccess) {
      <span class="absolute top-2 right-2 border border-red-500 rounded-full pt-1 px-1 bg-white dark:bg-[var(--p-content-background)] shadow-md">
        <i class="pi text-red-500"
         [ngClass]="{
    'pi-heart': !app?.isFavoriteLoading && !app?.isFavorite,
    'pi-heart-fill': !app?.isFavoriteLoading && app?.isFavorite,
    'pi-spinner pi-spin': app?.isFavoriteLoading,
    'pointer-events-none opacity-60': app?.isFavoriteLoading
  }"
          (click)="manageFavoriteApp(app)"
          >
        </i>
      </span>
    }
    <a [href]="app?.link"
      target="_blank"
      rel="noopener noreferrer">
      <!-- === CARD CONTENT === -->
      <div [class.opacity-30]="isRequiredAccess" [class.pointer-events-none]="isRequiredAccess">
        <img [src]="app?.image" [alt]="app?.title"
          class="w-full h-32 object-contain mb-4"
          onerror="this.src='assets/no-image.png'" />

          <div class="flex justify-between items-center w-full">
            <h2 class="font-semibold lg:text-xl text-lg mb-2 line-clamp-1" [title]="app?.title">
              {{ app?.title }}
            </h2>

            @if (app?.description) {
              <i class="pi pi-info-circle text-brand cursor-pointer"
              (click)="popover.toggle($event); $event.preventDefault()"></i>
            }
          </div>

          <!-- ℹ️ Popover -->
          <p-popover #popover styleClass="launchpad-popover">
            <ng-template #content>
              <div class="max-w-md text-sm text-gray-700 dark:text-gray-200 max-h-60 overflow-y-auto">
                <strong>{{ app?.title }}</strong>
                <div class="mt-1" [innerHTML]="app?.description"></div>
              </div>
            </ng-template>
          </p-popover>

          <p class="text-gray-600 dark:text-gray-400 text-sm line-clamp-2"
            [title]="app?.shortDescription">
            {{ app?.shortDescription }}
          </p>
        </div>
      </a>



      <!-- 🔒 RESTRICTED OVERLAY -->
      @if (isRequiredAccess) {
        <div
          class="absolute inset-0 bg-black/50 backdrop-blur-sm flex flex-col items-center justify-center gap-3 px-4 rounded-lg z-20">
          <h2 class="font-semibold lg:text-xl text-lg mb-2 line-clamp-1 text-white" [title]="app?.title">
            {{ app?.title }}
          </h2>
          <a [href]="requestAccess(app)" target="_blank">
            <p-button icon="pi pi-lock" [label]="'launchpad.requestAccess' | translate"/>
          </a>
          @if (app?.description) {
            <p-button icon="pi pi-info-circle" (click)="popover.toggle($event)" severity="secondary"
              [label]="'launchpad.moreDetails' | translate"/>
          }
        </div>
      }
    </div>
  </ng-template>



